var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAudio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83052 6.05708C8.83052 6.05708 12.8095 2.72208 15.1265 0.780081C15.4205 0.533081 15.8315 0.480082 16.1795 0.642082C16.5275 0.804082 16.7495 1.15408 16.7495 1.53808C16.7495 6.11508 16.7495 16.8851 16.7495 21.4621C16.7495 21.8461 16.5275 22.1961 16.1795 22.3581C15.8315 22.5201 15.4205 22.4671 15.1265 22.2201C12.8095 20.2781 8.83052 16.9431 8.83052 16.9431H6.07052C3.06552 16.9431 0.629517 14.5071 0.629517 11.5021V11.4981C0.629517 8.49308 3.06552 6.05708 6.07052 6.05708H8.83052ZM21.3165 5.52808C21.3165 5.52808 23.3695 7.69708 23.3695 11.5001C23.3695 15.3031 21.3165 17.4721 21.3165 17.4721C20.7375 18.0631 20.7485 19.0141 21.3395 19.5931C21.9315 20.1721 22.8825 20.1611 23.4615 19.5701C23.4615 19.5701 26.3695 16.6661 26.3695 11.5001C26.3695 6.33408 23.4615 3.43008 23.4615 3.43008C22.8825 2.83908 21.9315 2.82808 21.3395 3.40708C20.7485 3.98608 20.7375 4.93708 21.3165 5.52808Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudio);
export default __webpack_public_path__ + "static/media/icon_audio.79041723b9c17f83862a60d12a0bae2d.svg";
export { ForwardRef as ReactComponent };